// Global mixins

export default {

    methods: {

        /**
         * Send browser to URL
         *
         * @param url
         * @param newWindow
         */
        sendToUrl(url, newWindow = false) {
            if (newWindow) {
                window.open(url, '_blank').focus();
            } else {
                window.location.replace(url);
            }
        },

        /**
         * Dump object as JSON to the console
         *
         * @param object
         */
        dump(object) {
            console.log(JSON.parse(JSON.stringify(object)));
        },

        /**
         * Deep clone, gets rid of any references
         *
         * @param object
         * @returns {*}
         */
        deepClone(object) {
            return JSON.parse(JSON.stringify(object));
        },

        /**
         * Static assets
         *
         * @param filename
         * @returns {string}
         */
        cdnBaseUrl(filename) {
            if (filename) {
                // Remove beginning slash
                if (filename.substring(0, 1) === '/') filename = filename.substring(1);
                return window.cdnPath + '/' + filename;
            }
        },

        /**
         * Assets uploaded by user
         *
         * @param filename
         */
        cdnStorageBaseUrl(filename) {
            if (filename) {
                // Remove beginning slash
                if (filename.substring(0, 1) === '/') filename = filename.substring(1);
                return window.cdnPathStorage + '/' + filename;
            }
        },

        /**
         * Capitalize first character
         *
         * @param string
         * @returns {string}
         */
        ucFirst(string) {
            if (typeof string === 'string') {
                return string.charAt(0).toUpperCase() + string.slice(1);
            } else {
                return '';
            }
        },

        /**
         * Check if feature flag exists
         *
         * @param feature
         * @returns {boolean}
         */
        hasFeature(feature) {
            return this.$store.state.settings.features.includes(feature);
        },

        /**
         * Has role helper
         *
         * @param roleName
         * @returns {boolean}
         */
        hasRole(roleName) {
            return !!this.$store.state.user.roles.find(role => role.name === roleName);
        },

        /**
         * Has any role helper
         *
         * @param roles
         * @returns {boolean}
         */
        hasAnyRole(roles) {
            const result = roles.find(roleName => {
                return this.$store.state.user.roles.find(role => role.name === roleName);
            });
            return !!result;
        },

        /**
         * Has permission helper
         *
         * @param permissionName
         * @returns {boolean}
         */
        hasPermission(permissionName) {
            return !!this.$store.state.user.permissions.find(permission => permission.name === permissionName);
        },

        /**
         * Has any of the given permissions
         *
         * @param permissions
         * @returns {boolean}
         */
        hasAnyPermission(permissions) {
            const result = permissions.find(permissionName => {
                return this.$store.state.user.permissions.find(permission => permission.name === permissionName);
            });
            return !!result;
        },

        /**
         * Calculates difference of two arrays. Return all elements from array 1 that do not exist in array 2
         *
         * @param arr1
         * @param arr2
         * @returns {*}
         */
        arrayDiff(arr1, arr2) {
            return arr1.filter(x => !arr2.includes(x));
        },

        /**
         * Is panel in demo mode
         *
         * @returns {*}
         */
        isDemo() {
            return this.$store.state.PanelSettings.settings.demo_mode;
        },

        /**
         * Show first 422 Laravel error to the user
         *
         * @param error AxiosError
         */
        displayFirstLaravelError(error) {

            const firstError = Object.values(error.response.data.errors)[0][0];

            Bus.$emit('flash-message', {
                type: 'error',
                message: firstError
            });
        }
    },
}
